import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Link from 'shared/components/Link';
import { Controls } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
var Form = Controls.Form;
var OrderDetailsWrapper = function OrderDetailsWrapper(_ref) {
  var methods = _ref.methods,
    newOrder = _ref.newOrder,
    editingOrderDetails = _ref.editingOrderDetails,
    returnUrl = _ref.returnUrl,
    children = _ref.children,
    onSubmit = _ref.handleSubmit,
    title = _ref.title;
  var OrderDetailsContent = newOrder ? 'div' : Form;
  return /*#__PURE__*/React.createElement("div", {
    className: "container new-button-styles order-details ".concat(editingOrderDetails ? 'editing' : 'false')
  }, newOrder ? /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Thank you!"
  }) : /*#__PURE__*/React.createElement(IdentifyPage, {
    title: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "row mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Link, {
    to: returnUrl
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-arrow-left"
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "Back to my orders"
  })))), /*#__PURE__*/React.createElement(OrderDetailsContent, {
    className: "order-details-content",
    methods: !newOrder ? methods : undefined,
    onSubmit: !newOrder ? onSubmit : undefined
  }, children));
};
export default OrderDetailsWrapper;